import { cn } from '@simplywallst/ui-core/next';
import type { ComponentProps, ReactNode } from 'react';

type Props = {
  children: ReactNode;
} & ComponentProps<'section'>;

export const NarrativeCommunityListLayout = ({
  children,
  className,
  ...rest
}: Props) => {
  return (
    <section className={cn('grid grid-cols-1 gap-x2', className)} {...rest}>
      {children}
    </section>
  );
};
